<template>
  <div
    :class="[
      sticky
        ? 'sticky top-0 z-10 bg-gray-50 dark:bg-gray-900 -mx-2 px-2 sm:-mx-4 sm:px-4 pt-2 pb-0'
        : ''
    ]"
  >
    <div class="border-b border-gray-200 dark:border-gray-700">
      <div
        class="flex flex-col gap-3 pb-3 sm:pb-0 sm:flex-row sm:items-center sm:justify-between sm:min-h-[52px]"
      >
        <!-- Tabs - horizontally scrollable on mobile -->
        <nav
          v-if="tabs.length > 0"
          class="-mb-px flex space-x-2 sm:space-x-4 overflow-x-auto pb-1 sm:pb-0"
          :class="controlsFirst ? 'order-2 sm:order-1' : ''"
        >
          <button
            v-for="tab in tabs"
            :key="tab.key"
            @click="$emit('update:modelValue', tab.key)"
            :title="tab.description || undefined"
            :class="[
              'py-2 px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap',
              modelValue === tab.key
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
            ]"
          >
            {{ tab.label }}
            <span
              v-if="tab.count !== undefined"
              class="ml-1 sm:ml-2 bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-100 py-0.5 px-1.5 sm:px-2 rounded-full text-[10px] sm:text-xs min-w-[1.5rem] sm:min-w-[2rem] inline-block text-center"
            >
              {{ tab.count ?? '-' }}
            </span>
          </button>
        </nav>

        <!-- Fallback slot when no tabs (e.g., a static label) -->
        <div
          v-else-if="$slots.empty"
          class="-mb-px flex pb-1 sm:pb-0"
          :class="controlsFirst ? 'order-2 sm:order-1' : ''"
        >
          <slot name="empty" />
        </div>

        <!-- Right side slot for controls (search, buttons, selectors, etc.) -->
        <div
          v-if="$slots.controls"
          class="flex items-center gap-2 sm:gap-3 sm:mb-2"
          :class="controlsFirst ? 'order-1 sm:order-2' : ''"
        >
          <slot name="controls" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  /**
   * Array of tab objects with: { key: string, label: string, count?: number, description?: string }
   */
  tabs: {
    type: Array,
    required: true
  },
  /**
   * The currently selected tab key (v-model)
   */
  modelValue: {
    type: String,
    required: true
  },
  /**
   * Whether to make the header sticky (default: true)
   */
  sticky: {
    type: Boolean,
    default: true
  },
  /**
   * Whether the controls should appear first on mobile (default: false)
   */
  controlsFirst: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:modelValue'])
</script>
